import { useRecoilCallback } from 'recoil';
export const useSetStale = ({ staleState, }) => {
    const refetch = useRecoilCallback(({ set }) => () => {
        set(staleState, `${new Date().valueOf()}`);
    }, [staleState]);
    return refetch;
};
export default useSetStale;
//# sourceMappingURL=use-set-stale.js.map